import { GalleryButton } from './styles';
import Icon from 'src/units/Icon';
import { ArrowDirection, ArrowProps } from './types';
import { FC } from 'react';
import { DeviceManager } from 'src/utils';

export const Arrow: FC<ArrowProps & { children?: any }> = ({
  className,
  style,
  onClick,
  direction,
}) => {
  return (
    <GalleryButton
      className={className}
      style={{
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
                linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))`,
        // @ts-ignore
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
        // @ts-ignore
        ' &:focus': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
        ...(direction === ArrowDirection.Left && {
          left: DeviceManager.isMobile() ? '10px' : '20px',
        }),
        ...(direction === ArrowDirection.Right && {
          right: DeviceManager.isMobile() ? '10px' : '20px',
        }),
        ...style,
      }}
      onClick={onClick}
    >
      {direction === ArrowDirection.Left && <Icon.ChevronLeft style={{ color: 'white' }} />}
      {direction === ArrowDirection.Right && <Icon.ChevronRight style={{ color: 'white' }} />}
    </GalleryButton>
  );
};
